var module = angular.module('octopusApp.infrastructure');

module.factory('sensitiveValue', function () {

    return {
        // Returns a reset-value function for use with bound-field directive
        getResetValue: function (model) {

            // If not an object, then it wasn't a sensitive-value
            if (typeof(model) !== 'object') {
                return function () {
                    return {HasValue: false};
                };
            }

            var initial = _.clone(model);
            return function () {
                return _.clone(initial);
            };
        }
    };

});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/sensitive_value.js
// module id = 2366034489697447
// module chunks = 1